import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ResourceType } from '../../models/resourcetype';

@Injectable({
	providedIn: 'root'
})
export class ResourceNavigationService {

	constructor(private navCtrl: NavController) {}

	navigate(resourceType: ResourceType, resourceId: string): Promise<boolean> {
		return this.navCtrl.navigateForward(this.routeFor(resourceType, resourceId));
	}

	private routeFor(resourceType: ResourceType, resourceId: string): string {
		switch (resourceType) {
			case ResourceType.Tournament:
				return `/tabs/tournaments/detail/${resourceId}`;
			case ResourceType.Match:
				return `/tabs/matches/detail/${resourceId}`;
			case ResourceType.League:
				return `/tabs/tournaments/leagues/detail/${resourceId}`;
			case ResourceType.Team:
				return `/tabs/teams/detail/${resourceId}`;
			case ResourceType.Place:
				return `/tabs/places/detail/${resourceId}`;
		}
	}
}
